import { FC, useEffect } from 'react'
import { useMap, MapContainerProps } from 'react-leaflet'

type Props = Pick<MapContainerProps, 'bounds' | 'boundsOptions'>

export const FitMap: FC<Props> = ({
  bounds,
  boundsOptions = { paddingTopLeft: [10, 60], paddingBottomRight: [10, 60] },
}) => {
  const map = useMap()

  useEffect(() => {
    if (bounds) {
      map.fitBounds(bounds, boundsOptions)

      map.fire('fitBounds')
    }
  }, [map, bounds, boundsOptions])

  return null
}
